<template>
  <div class="locale-changer">
    <button
      href="#"
      class="flex items-center"
      @click="toggleVisibility"
      @keydown.space.exact.prevent="toggleVisibility"
      @keydown.esc.exact="hideDropdown"
      @keydown.shift.tab="hideDropdown"
      @keydown.up.exact.prevent="startArrowKeys"
      @keydown.down.exact.prevent="startArrowKeys"
    >
      <span class="selected-locale">{{ $i18n.locale.toUpperCase() }}</span>
    </button>
    <transition name="dropdown-fade">
      <ul
        v-on-clickaway="hideDropdown"
        v-if="isVisible"
        ref="dropdown"
        class="locale-dropdown"
      >
        <li @click="forceRerender">
          <a
            href="#"
            @click.prevent="setLocale('en')"
            ref="account"
            class="flex items-center"
            @keydown.up.exact.prevent=""
            @keydown.tab.exact="focusNext(false)"
            @keydown.down.exact.prevent="focusNext(true)"
            @keydown.esc.exact="hideDropdown"
          >
            <!-- <img src="/flag_en.svg" alt="english flag"> -->
            <span class="ml-2">EN</span>
          </a>
        </li>
        <li>
          <a
            href="#"
            @click.prevent="setLocale('fa')"
            class="flex items-center"
            @keydown.shift.tab="focusPrevious(false)"
            @keydown.up.exact.prevent="focusPrevious(true)"
            @keydown.down.exact.prevent=""
            @keydown.tab.exact="hideDropdown"
            @keydown.esc.exact="hideDropdown"
          >
            <!-- <img src="/flag_fr.svg" alt="english flag"> -->
            <span class="ml-2">FA</span>
          </a>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
import { mixin as clickaway } from "vue-clickaway";
export default {
  mixins: [clickaway],
  data() {
    return {
      isVisible: false,
      focusedIndex: 0,
      localee:"fa",
      componentKey:0,
    };
  },
  methods: {
        forceRerender() {
      this.componentKey += 1;
    },
    toggleVisibility() {
      this.isVisible = !this.isVisible;
    },
    hideDropdown() {
      this.isVisible = false;
      this.focusedIndex = 0;
    },
    //    checkDirection(e) {
    //   if (e.target.options.selectedIndex == 1) {
    //     document.body.classList.add("ltr");
    //     document.body.classList.remove("rtl");
    //   } else if (e.target.options.selectedIndex == 0) {
    //     document.body.classList.remove("ltr");
    //     document.body.classList.add("rtl");
    //   }
    // }
    startArrowKeys() {
      if (this.isVisible) {
        // this.$refs.account.focus()
        this.$refs.dropdown.children[0].children[0].focus();
      }
    },
    focusPrevious(isArrowKey) {
      this.focusedIndex = this.focusedIndex - 1;
      if (isArrowKey) {
        this.focusItem();
      }
    },
    focusNext(isArrowKey) {
      this.focusedIndex = this.focusedIndex + 1;
      if (isArrowKey) {
        this.focusItem();
      }
    },
    focusItem() {
      this.$refs.dropdown.children[this.focusedIndex].children[0].focus();
    },
    setLocale(locale) {
      if (document.body.classList.contains('rtl'))
      {
        document.body.classList.remove("rtl");
        document.body.classList.add("ltr");
      }
      else{
        document.body.classList.remove("ltr");
        document.body.classList.add("rtl");
      }
      this.$i18n.locale = locale;
      this.$router.push({
        params: { lang: locale },
      });
      this.hideDropdown();
    },
  },
};
</script>

<style scoped>
.locale-changer button {
  padding: 5px;
  background: transparent;
  border: none;
}
.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
  transition: all 0.1s ease-in-out;
}
.dropdown-fade-enter,
.dropdown-fade-leave-to {
  opacity: 0;
  transform: translateY(-12px);
}
.locale-dropdown {
  position: absolute;
  left: 20px;
  width: 115%;
}
.locale-dropdown li {
  padding: 8px;
  list-style: none;
  background: rgb(255 255 255 / 34%);
  margin-bottom: 3px;
  font-size: 14px;
}
.selected-locale {
  position: relative;
  font-size: 16px;
}
.selected-locale:before {
  content: " ";
  position: absolute;
  top: 6px;
  right: -10px;
  width: 0;
  height: 0;
  border-style: solid;
  border-right: 3px solid transparent;
  border-left: 4px solid transparent;
  border-top: 8px solid #555555;
  border-bottom: 0;
  transform: skew(-5deg) rotate(-4deg);
}
</style>